import { render, staticRenderFns } from "./ReferralLinkModal.vue?vue&type=template&id=2f566691&scoped=true"
import script from "./ReferralLinkModal.vue?vue&type=script&lang=js"
export * from "./ReferralLinkModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralLinkModal.vue?vue&type=style&index=0&id=2f566691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f566691",
  null
  
)

export default component.exports